import React from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useLayoutEffect } from "react";

import styles from "./HowToWin.module.scss";
import logo from "../../img/howToWin/logo.png";

const HowToWin = ({ howTowinRef }) => {
  gsap.registerPlugin(ScrollTrigger);

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      let SECTIONS = gsap.utils.toArray("section");
      gsap.to(SECTIONS, {
        xPercent: -100 * (SECTIONS.length - 1),
        ease: "none",
        scrollTrigger: {
          trigger: howTowinRef.current,
          start: "center center",
          end: () => "+=" + 100 * SECTIONS.length + "%",
          pin: true,
          scrub: true,
          snap: {
            snapTo: 1 / (SECTIONS.length - 1),
            duration: 0.1,
            delay: 0.1,
            ease: "none",
          },
          invalidateOnRefresh: true,
          pinSpacing: "margin",
          markers: false,
        },
      });
    }, howTowinRef);
    return () => ctx.revert();
  });
  /*
 snap: {
              snapTo: 1 / (SECTIONS.length - 1),,
              duration: 0.2,
              delay: 0.1,
              ease: "none",
            }
*/
  return (
    <div id={styles.container}>
      <div
        id={styles.contents}
        className={styles.contents_box}
        ref={howTowinRef}
      >
        <h1 className={styles.title} data-content="How to Win!">
          How to Win!
        </h1>
        <section className={styles.section01}>
          <h1
            className={styles.section_one_title}
            data-content="Meet minimum KPI for all metrics"
          >
            Meet minimum KPI for all metrics
          </h1>
          <div className={styles.section_one_img}>
            <div className={styles.circle_one}></div>
            <div className={styles.circle_two}></div>
            <div className={styles.circle_three}></div>
          </div>
        </section>
        <section className={styles.section02}>
          <h1 className={styles.section_two_title}>
            <span data-content="Obtain at least">Obtain at least</span>
            <span data-content="3 points">3 points</span>
          </h1>
          <div className={styles.section_two_img}>
            <div className={styles.circle_one}></div>
            <div className={styles.circle_two}></div>
            <div className={styles.circle_three}></div>
          </div>
        </section>
        <section className={styles.section03}>
          <h1 className={styles.section_three_title}>
            <span data-content="Publish with">Publish with</span>
            <span data-content="MondayOFF">MondayOFF</span>
          </h1>
          <img className={styles.logo} src={logo} alt="logo" />
        </section>
      </div>
    </div>
  );
};

export default HowToWin;
